import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import ProjectInstallmentFundingConditionFile from "../../../interfaces/project-installment-funding-condition-file";
import {FormControl} from "@angular/forms";
import {EquityInstallmentService, UpdateInstallmentObservableMode} from "../../equity-installment.service";
import {Subscription} from "rxjs";
import {
  EquityInstallmentSharepointService
} from "../equity-installment-documents-panel/equity-installment-sharepoint.service";

@Component({
    selector: 'equity-installment-file',
    templateUrl: './equity-installment-file.component.html',
    styleUrls: ['./equity-installment-file.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EquityInstallmentFileComponent implements OnInit{
  @Input() file:ProjectInstallmentFundingConditionFile;
  @Input() readOnly:boolean = false
  @Input() isInvalid:boolean = false
  public includePackageControl: FormControl = new FormControl<boolean>(false)
  private userSub: Subscription;
  public user:any;

  constructor(private equityService: EquityInstallmentService, private sharepointService: EquityInstallmentSharepointService) {
  }

  ngOnInit() {
    this.userSub = this.equityService.user$.subscribe((result) => this.user = result)

    this.includePackageControl.setValue(this.file.include_in_package)
    this.includePackageControl.valueChanges.subscribe((change:any) => {
      this.equityService.updateIncludeInPackageStatus(this.file.id, change).subscribe((result) => {
        this.equityService.openSnackBar('File updated', 'save-success')
        this.equityService.updateConditionFiles(UpdateInstallmentObservableMode.UPDATE, this.file)
      })
    })


  }

  deleteFile(){
    //this.sharepointService.removeSiteFile(this.file)
    this.equityService.deleteConditionFile(this.file.id).subscribe((response:any) => {
      this.equityService.openSnackBar('File removed', 'save-success')
      this.equityService.updateConditionFiles(UpdateInstallmentObservableMode.REMOVE, this.file)
    })
  }


  ngOnDestroy(){
    this.userSub.unsubscribe();
  }

}
